import React, { useContext } from "react";

import CameraComparisonContext from "../CameraComparisonContext";
import { useComparisonCheckbox } from "./useComparisonCheckbox";

import translate from "../../../../lib/translate"

import * as styles from "./compareCheckBox.module.less";

export function CompareCheckBox({ cameraId }) {
    const inputName = `check-${cameraId}`;

    const comparisonContext = useContext(CameraComparisonContext);

    const { bind, disabled } = useComparisonCheckbox(
        comparisonContext,
        cameraId
    );

    return (
        <div className={styles.compareCheckContainer}>
            <label htmlFor={inputName}>{translate('camera.teaser.compare.checkbox')}</label>

            <input
                type="checkbox"
                name={inputName}
                className={styles.checkbox}
                {...bind}
                disabled={disabled}
            />
        </div>
    );
}
